import RHFInput from './RHFInput.component';

export default RHFInput;
